import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Icon from '/component/base/Icon/Icon';
import Text from '/component/base/Text';
import {IncentiveTrip} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './Requirements.style';
import {NewCoachProps} from './Requirements.types';

export const NewCoach = ({
  iconColor = '#000',
  newCoachCount = {
    currentCount: 0,
    targetCount: 0,
  },
}: NewCoachProps) => {
  const {ts} = useTranslation('requirements.coach');

  const currentCount = get(newCoachCount, 'currentCount', 0);
  const targetCount = get(newCoachCount, 'targetCount', 0);
  const isQualified = currentCount >= targetCount;

  return (
    <View
      style={styles.progressBarContainer}
      {...testProperties(
        IncentiveTrip.itNewCoachWithQualifyingClientGoalCheckbox,
        true,
      )}>
      <Icon
        name={isQualified ? 'circle-checkmark-filled' : 'circle'}
        style={{
          ...styles.circleCheckMarkIcon,
          color: iconColor,
          ...(isQualified
            ? styles.circleCheckedFilledFont
            : styles.circleUnFilledFont),
        }}
        testID={`${IncentiveTrip.itNewCoachWithQualifyingClientGoalCheckbox}-${
          isQualified ? 'checked' : 'unchecked'
        }`}
      />
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        variant="caption"
        // @ts-expect-error TS(2339): Property 'boxTitle' does not exist on type '{ boxe... Remove this comment to see the full error message
        style={styles.boxTitle}
        {...testProperties(IncentiveTrip.itNewCoachWithQualifyingClientLabel)}>
        {ts('newCoach', '1 new Coach with at least 1 new qualifying Client')}
      </Text>
    </View>
  );
};
